import React, { useState, useEffect } from 'react'
import {
  Row,
  Col,
  Button,
  Card,
  Pagination,
} from 'antd'
import Layouts from '../components/Layouts'
import { FileDoneOutlined } from '@ant-design/icons';
import apiRequest from '../hooks/ApiRequest'
import { useHistory } from 'react-router-dom';
 
const DiarySystem = () => {
  const LoginUser = localStorage.getItem('username');
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const history = useHistory();
 
  useEffect(() => {
    const fetchDummyData = async () => {
      try {
        const res = await apiRequest(process.env.REACT_APP_BASE_URL + '/api/BrokerDiary', 'GET');
 
        if (res.success) {
          setData(res.data[0].diaries);
        }
      } catch (error) {
        console.error('Error fetching dummy API:', error);
      }
    };
 
    fetchDummyData();
  }, []);
 
 
  const deleteTask = async (id) => {
    try {
      const res = await apiRequest(process.env.REACT_APP_BASE_URL + `/api/BrokerDiary/${id}`, 'POST');
 
      if (res.success) {
        console.log('Task deleted successfully');
      }
    } catch (error) {
      console.error('Error fetching dummy API:', error);
    }
  };
 
  const paginatedData = data.slice((currentPage - 1) * pageSize, currentPage * pageSize);
 
  return (
    <div title="assets" className="ant-layout-content dashboard">
      <div className="dash-bg-white">
        <Row gutter={16}>
          <Col xs={24} sm={24} md={12}>
          <div className="section-top-heading">
            <h3 style={{ color: '#0C1362', fontWeight: '600', fontSize: 20 }}>
              DIARY SYSTEM
            </h3>
          </div>
          </Col>
        </Row>
      </div>
      <div className="dash-bg-white">
        <Card
          title={<h3 style={{ marginBottom: 0 }}>Outstanding Tasks</h3>}
          bordered={false}
          style={{ borderRadius: 8 }}
        >
          {data.length ? (
            <>
              <p>Welcome back, {LoginUser}. Here are your pending actions.</p>
              <div style={{ marginTop: 16 }}>
                {paginatedData.map(item => (
                  <Row
                    key={item.id}
                    style={{
                      background: '#fff',
                      border: '1px solid #e8e8e8',
                      borderRadius: 8,
                      padding: 16,
                      marginBottom: 16,
                      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                      display: 'flex',
                      flexWrap: 'wrap',   // allow wrapping on small screens
                      alignItems: 'center', // center icon & text vertically
                      gap: '16px'          // spacing between icon and text
                    }}
                  >
                    <div
                      style={{
                        width: 40,
                        height: 40,
                        backgroundColor: '#0c1362',
                        borderRadius: '50%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexShrink: 0,  // don't shrink the icon on small screens
                      }}
                    >
                      <FileDoneOutlined style={{ color: '#fff', fontSize: 18 }} />
                    </div>
 
                    <div style={{ flex: '1 1 60%' }}>
                      <h4 style={{ marginBottom: 4 }}>{item.entityType}</h4>
                      <p style={{ marginBottom: 0, color: '#555' }}>{item.message}</p>
                    </div>
 
                    <div style={{ flex: '0 0 auto', textAlign: 'right' }}>
                      <Button
                        type="default"
                        style={{ width: '100%', maxWidth: 120 }}
                        onClick={() => {
                          if (item.entityType === 'Policy') {
                            localStorage.setItem('productId', item.productId);
                            history.push(`/policies/${item.entityNumber}`);
                            deleteTask(item.id);
                          } else if (item.entityType === 'Quotation') {
                            localStorage.setItem('productId', item.productId);
                            history.push(`/quotations/${item.entityNumber}`);
                            deleteTask(item.id);
                          } else {
                            window.open('https://outrisk-claim.kindlebit.com/', '_blank');
                          }
                        }}
                      >
                        View
                      </Button>
                    </div>
                  </Row>

                ))}
              </div>
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={data.length}
                onChange={page => setCurrentPage(page)}
                style={{ textAlign: 'center', marginTop: 20 }}
              />
            </>
          ) : (
            <p>Welcome back, {LoginUser}. There are no pending actions currently.</p>
          )}
        </Card>
      </div>
 
    </div>
  )
}
 
export default DiarySystem
 